<template>
  <div>
    <index-card fluid>
      <template slot="header">
        <v-row>
          <v-col class="white--text d-flex justify-space-between align-center headline">
            <div>
              <v-btn icon color="blue-grey darken-1" :to="{name: 'Home'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
              <v-btn class="ml-2" color="white black--text" @click="dialog_new_bill = true"><v-icon left>mdi-plus</v-icon>novo boleto</v-btn>
            </div>
            <span>Boletos</span>
            <div class="d-flex">
              <BtnCreateDataExport 
              class="mx-3"
              api_model="Bill" 
              action="Bills"
              :filters="filters"
              ></BtnCreateDataExport>
              <v-btn text icon color="white" aria-label="Atualizar lista" @click="reload">
                <v-icon color="white">mdi-refresh</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
      <template slot="data_table">
        <v-card>
          <v-card-text>
            <div>
              <filter-data
                with_client_portfolios
                :loading_block="loading"
                :months_before="3"
                :months_after="2"
                with_company
                with_text_search
                with-bill-situation-select
                :bill-situation-items="bill_type"
                :bill-situation-value="bill_filter"
                text_search_label="Pesquisar ( Núm. Documento, Núm. Pedido, Nosso Número )"
                @doneFilter="handleDoneFilter"
              />
              <bill-table 
                :items="allBills" 
                :loading='loading'
                :pagination="pagination"
                :show-canceled-columns="showCanceledColumns"
                @doneUpdate='handleDoneUpdate' 
                @doneSent="handleDoneSent"
                @doneConclude="handleDoneConclude"
                @doneDelete="handleDoneDelete"
                @pageChange="handlePageChange"
                @perPageChange="handlePerPageChange"
                @sortChange="handleSortChange"
              ></bill-table>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </index-card>
    <dialog-new-bill v-if="dialog_new_bill" @close="handleClose" @doneNewBill="hendleDoneNewBill"></dialog-new-bill>
  </div>
</template>

<script>
const OPEN_ID = 6
const CONCLUDED_ID = 16
import { mapActions, mapState, mapGetters } from 'vuex'
import status from "@/_backoffice/_financial/mixins/status.js"

export default {
  name: 'Bills',
  mixins: [status],
  components: {
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    DialogNewBill: () => import("./DialogNewBill.vue"),
    BtnCreateDataExport: () => import("@/components/data_export/BtnCreateDataExport.vue"),
    BillTable: () => import('./shared/BillTable'),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      dialog_new_bill: false,
      filters: {},
      loading: false,
      comment: '',
      comment_dialog: false,

      local_filter: {},
      sortBy: null,
      sortDesc: false,
      bill_filter: {
        by_concluded: false,
        status_ids: [OPEN_ID],
      },
      bill_type:[
        {text:"ABERTOS", value: {
          by_concluded: false,
          status_ids: [OPEN_ID],
        }},
        {text:"CONCLUÍDOS", value:{
          by_concluded: true,
          status_ids: [CONCLUDED_ID],
        }},
        {text:"CANCELADOS", value:{
          by_concluded: true,
          status_ids: [OPEN_ID],
        }},
      ],
    }
  },
  methods: {
    handleClose(){
      this.dialog_new_bill = false
    },
    hendleDoneNewBill(){
      this.reload()
    },
    reload() {
      const limit = this.pagination ? this.pagination.per_page : 10
      const page = this.pagination ? this.pagination.current_page : 1
      this.getBills(page, limit)
    },

    handleDoneFilter(e) {
      const { by_concluded, status_ids, ...rest } = e
      if (by_concluded !== undefined && status_ids !== undefined) {
        this.bill_filter = { by_concluded, status_ids: [...status_ids] }
      }
      this.local_filter = { ...rest }
      const limit = this.pagination ? this.pagination.per_page : 10
      const page = this.pagination ? this.pagination.current_page : 1
      this.getBills(page, limit)
      this.filters = { ...e }
    },
    handleDoneUpdate(e){
      const limit = this.pagination ? this.pagination.per_page : 10
      const page = this.pagination ? this.pagination.current_page : 1
      this.getBills(page, limit)
    },
    handleDoneSent(e){
      const limit = this.pagination ? this.pagination.per_page : 10
      const page = this.pagination ? this.pagination.current_page : 1
      this.getBills(page, limit)
    },
    handleDoneConclude(e){
      const limit = this.pagination ? this.pagination.per_page : 10
      const page = this.pagination ? this.pagination.current_page : 1
      this.getBills(page, limit)
    },
    handleDoneDelete(e){
      const limit = this.pagination ? this.pagination.per_page : 10
      const page = this.pagination ? this.pagination.current_page : 1
      this.getBills(page, limit)
    },
    seeComment(comment) {
      this.comment = comment
      this.comment_dialog = true
    },
    getBills(page = 1, limit = 10){
      if (this.loading == false && this.activeModalityId){
        this.loading = true
        let filters = {
          modality_ids: [this.activeModalityId],
          page: page,
          limit: limit,
          ...this.local_filter,
          ...this.bill_filter
        }
        if (this.sortBy) {
          const sortFieldMap = {
            'attributes.nf_due': 'nf_due',
            'attributes.concluded_at': 'concluded_at',
            'attributes.value': 'value',
            'attributes.client_name': 'client_name',
            'attributes.nf_number': 'nf_number',
            'attributes.our_number': 'our_number',
            'attributes.company': 'company',
            'attributes.place_name': 'place_name',
            order: 'order_id',
          }
          filters.sort_field = sortFieldMap[this.sortBy] || this.sortBy
          filters.sort_dir = this.sortDesc ? 'desc' : 'asc'
        }
        this.filters = { ...filters }
        this.$emit('doneFilter', {...filters} )
        if (this.activeModalityId){
          this.indexBills(filters).finally(()=>{
            this.loading = false
          })
        }
      }
    },
    handlePageChange(page) {
      // Pegar itemsPerPage atual do pagination do store
      const limit = this.pagination ? this.pagination.per_page : 10
      this.getBills(page, limit)
    },
    handlePerPageChange(perPage) {
      // Resetar para primeira página ao mudar itens por página
      this.getBills(1, perPage)
    },
    handleSortChange({ sortBy, sortDesc }) {
      this.sortBy = sortBy
      this.sortDesc = sortDesc
      const limit = this.pagination ? this.pagination.per_page : 10
      this.getBills(1, limit)
    },
    ...mapActions({
      indexBills: 'Bill/index',
    })
  },
  computed: {
    ...mapState({
      allBills: state => state.Bill.allBills,
      pagination: state => state.Bill.pagination,
    }),
    showCanceledColumns() {
      const statusIds = this.bill_filter?.status_ids || []
      return this.bill_filter?.by_concluded === true && statusIds.length === 1 && Number(statusIds[0]) === OPEN_ID
    },
  },

  watch: {
    activeModalityId: {
      handler(newVal) {
        if (newVal) {
          const limit = this.pagination ? this.pagination.per_page : 10
          this.getBills(1, limit) // Resetar para primeira página ao mudar modality
        }
      },
      immediate: true
    },
  },
}
</script>
